import styled, { css } from 'styled-components';
import { IonSpinner } from '@ionic/react';

import colors from '../../../../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100%;
  min-height: 50vh;
`;

const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px 4px;
  column-gap: 16px;
  border-bottom: 1px solid ${colors.shades.gamma1};
`;

const DateColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 110px;
  row-gap: 4px;
`;

const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  row-gap: 2px;
  padding-top: 22px;
`;

const baseTextCss = css`
  font-size: 14px;
  text-align: left;
`;

const MessageText = styled.div`
  ${baseTextCss};
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MessageSubtitle = styled.div`
  font-size: 12px;
  color: ${colors.shades.gamma10};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MessageDate = styled.div`
  ${baseTextCss};
  font-weight: bold;
`;

const MessageTime = styled.div`
  ${baseTextCss};
  font-weight: bold;
`;

const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const InfoText = styled.div`
  ${baseTextCss};
  font-size: 18px;
  width: 100%;
  text-align: center;
`;

const StyledIonSpinner = styled(IonSpinner)`
  align-self: center;
  justify-self: center;
`;

export {
  Container,
  ItemContainer,
  DateColumn,
  ContentColumn,
  MessageText,
  MessageSubtitle,
  MessageDate,
  MessageTime,
  ActionsContainer,
  InfoText,
  StyledIonSpinner,
};
